import { Button, Typography, Box } from '@mui/material';
import SvgIconStyle from '@components/SvgIconStyle';
import { FC } from 'react';
import { styles } from './styles';

type Props = {
  title: string;
  onClose: (event: React.MouseEvent<HTMLElement>) => void;
};

const DialogTitle: FC<Props> = ({ title, onClose }) => (
  <Box sx={styles.dialogTitle}>
    <Typography variant="h6">{title}</Typography>
    <Button onClick={onClose} color="inherit" size="medium" sx={styles.closeButton}>
      <SvgIconStyle src="/icons/ic_close.svg" sx={styles.icon} />
    </Button>
  </Box>
);

export default DialogTitle;
